import { ChainId } from '@babydogeswap/sdk'

export const SNAPSHOT_VOTING_API = "https://xtjyd0liqe.execute-api.ap-northeast-1.amazonaws.com/dev/api"
export const SNAPSHOT_BASE_URL = "https://hub.snapshot.org"
export const SNAPSHOT_API = `${SNAPSHOT_BASE_URL}/graphql`
export const SNAPSHOT_HUB_API = `${SNAPSHOT_BASE_URL}/api/message`

export const INFO_METRICS = 'https://token-metrics-api.babydogeswap.com/current-metrics'

export const INFO_CLIENT_API = {
  [ChainId.MAINNET]: 'https://graph-bsc-mainnet.babydoge.com/subgraphs/name/babydoge/exchange',
  [ChainId.TESTNET]: 'https://graph-bsc-testnet.babydoge.com/subgraphs/name/babydoge/exchange'
}

export const TREATS_CLIENT_API = {
  [ChainId.MAINNET]: 'https://graph-bsc-mainnet.babydoge.com/subgraphs/name/babydoge/fixed-period-pool',
  [ChainId.TESTNET]: 'https://graph-bsc-testnet.babydoge.com/subgraphs/name/babydoge/fixed-period-pool'
}

export const BLOCKS_CLIENT_API = {
  [ChainId.MAINNET]: 'https://graph-bsc-mainnet.babydoge.com/subgraphs/name/babydoge/blocks',
  [ChainId.TESTNET]: 'https://graph-bsc-testnet.babydoge.com/subgraphs/name/babydoge/blocks'
}

export const NFT_API = {
  [ChainId.MAINNET]: 'https://babydoge-nft-api-bsc-testnet.vercel.app/api/v1',
  [ChainId.TESTNET]: 'https://babydoge-nft-api-bsc-testnet.vercel.app/api/v1'
}

export const NFTMARKET_API = {
  [ChainId.MAINNET]: 'https://graph-bsc-mainnet.babydoge.com/subgraphs/name/babydoge/nft-market',
  [ChainId.TESTNET]: 'https://graph-bsc-testnet.babydoge.com/subgraphs/name/babydoge/nft-market'
}

export const PROFILE_API = {
  [ChainId.MAINNET]: 'https://graph-bsc-mainnet.babydoge.com/subgraphs/name/babydoge/profile',
  [ChainId.TESTNET]: 'https://babydoge-profile-api-bsc-testnet.vercel.app'
}

export const FAAS_API = {
  [ChainId.MAINNET]: 'https://graph-bsc-mainnet.babydoge.com/subgraphs/name/babydoge/faas',
  [ChainId.TESTNET]: 'https://graph-bsc-testnet.babydoge.com/subgraphs/name/babydoge/faas'
}

export const BABYDOGE_METRICS_API = {
  [ChainId.MAINNET]: 'https://token-metrics-api.babydogeswap.com/current-metrics',
  [ChainId.TESTNET]: ''
}

export const WALLCHAIN_API = {
  [ChainId.MAINNET]: 'https://bsc.wallchains.com/upgrade_txn/?key=',
  // Doesnt exist on testnet as of writing
  [ChainId.TESTNET]: ''
}

export const BSC_SCAN_API_KEY = '7UG6HX1VNW76Z8FK2A9B5FTHU9QCQM9W68'

export const V3_SUBGRAPH_URLS = {
  [ChainId.MAINNET]: '',
  [ChainId.TESTNET]: 'https://graph-bsc-testnet.babydoge.com/subgraphs/name/babydoge/exchange-v3'
}

export const V3_FAAS_API = {
  [ChainId.MAINNET]: '',
  [ChainId.TESTNET]: 'https://graph-bsc-testnet.babydoge.com/subgraphs/name/babydoge/minting-farm-v3'
}